import { render, staticRenderFns } from "./SquareTab.vue?vue&type=template&id=21d44ae5&scoped=true&"
import script from "./SquareTab.vue?vue&type=script&lang=js&"
export * from "./SquareTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d44ae5",
  null
  
)

export default component.exports